const addLeadingZero = (num) => {
  return num.toString().padStart(2, '0');
};

export default {
  addLeadingZero
};
